/* « Mon espace » — le volet du compte client (fiche parcours-mon-espace, 21/10).
   Ouvre et ferme le volet rendu par snippets/bisou-mon-espace.liquid, comme le
   panier : l'icône du compte de l'en-tête ([data-bme-ouvrir]) et, une fois
   connecté, la tuile « Mon espace » du menu tiroir (le lien du compte dans
   #bisou-volet). Sans ce fichier, l'icône reste le lien Shopify d'avant.
   Rien n'est écrit nulle part : la liste d'envies est lue dans le navigateur,
   « a voté » par le même appel que le SAS, une seule fois, à la première
   ouverture. */
(function () {
  'use strict';

  var root = document.getElementById('BisouMonEspace');
  if (!root || root.__bme) return;
  root.__bme = true;

  /* Le volet sort de l'en-tête : un ancêtre filtré ou transformé ferait de
     « fixed » une position relative à lui. */
  document.body.appendChild(root);

  var volet = root.querySelector('.bme__volet');
  var connecte = root.getAttribute('data-bme-connecte') === '1';
  var compte = root.getAttribute('data-bme-compte') || '';
  /* 25/10 (site anglais) : la langue de la page (« fr » ou « en ») et sa racine (« » ou « /en ») ; une adresse
     de la boutique écrite ici, ou gardée dans la liste d'envies depuis l'autre langue, prend celle de la page. */
  var EN = !/^fr/i.test(document.documentElement.getAttribute('lang') || 'fr');
  var ROOT = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
  /* 27/10 (quatre langues) : une adresse gardée depuis /es ou /ja perd aussi son préfixe ; les libellés
     écrits ici viennent des clés de la langue, posées par le snippet (data-bme-n-un, -n-plus, -voir-vote). */
  function enLangue(u) { return u && u.charAt(0) === '/' && u.charAt(1) !== '/' ? ROOT + u.replace(/^\/(en|fr|es|ja)(?=\/|$)/, '') : u; }
  function libelle(nom, repli) { return root.getAttribute('data-bme-' + nom) || repli; }
  var avant = null;
  var voteVu = false;

  var FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function visibles() {
    return Array.prototype.filter.call(volet.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null;
    });
  }

  /* ─── La liste d'envies du navigateur (br_wishlist_v1, bisou-wishlist.js) ─── */
  function lireEnvies() {
    try {
      var d = JSON.parse(localStorage.getItem('br_wishlist_v1'));
      return d && Array.isArray(d.items) ? d.items : [];
    } catch (e) { return []; }
  }
  function lienSur(u) {
    u = String(u || '');
    return (u.charAt(0) === '/' && u.charAt(1) !== '/') || u.indexOf('https://') === 0 ? u : '';
  }
  function image(u, w) {
    u = String(u || '');
    if (u.indexOf('//') === 0) u = 'https:' + u;
    if (u.indexOf('https://') !== 0) return '';
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&]width=)\d+/, '$1' + w);
    return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
  }
  function remplirEnvies() {
    var liste = root.querySelector('[data-bme-envies]');
    if (!liste) return;
    var items = lireEnvies();
    var n = root.querySelector('[data-bme-envies-n]');
    var vide = root.querySelector('[data-bme-envies-vide]');
    if (n) n.textContent = items.length ? '· ' + (items.length > 1
      ? libelle('n-plus', EN ? '{count} prints' : '{count} tirages')
      : libelle('n-un', EN ? '{count} print' : '{count} tirage')).replace(/\{count\}/g, items.length) : '';
    if (vide) vide.hidden = items.length > 0;
    liste.textContent = '';
    /* R16 : le même ordre que la liste d'envies, le dernier aimé en tête (à date égale, le dernier ajouté) */
    items.map(function (it, i) { return { it: it, i: i }; })
      .sort(function (x, y) { return ((y.it.at || 0) - (x.it.at || 0)) || (y.i - x.i); })
      .slice(0, 4).map(function (x) { return x.it; }).forEach(function (it) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'bme__envie';
      a.href = enLangue(lienSur(it.u) || (it.h ? '/products/' + encodeURIComponent(it.h) : '/pages/wishlist?view=wishlist'));
      a.setAttribute('aria-label', it.t || (EN ? 'Print' : 'Tirage'));
      var src = image(it.img, 240);
      if (src) {
        var img = document.createElement('img');
        img.src = src;
        img.alt = '';
        img.loading = 'lazy';
        a.appendChild(img);
      }
      li.appendChild(a);
      liste.appendChild(li);
    });
    liste.hidden = items.length === 0;
  }

  /* ─── « A voté » : le même appel que le SAS, seulement s'il y a un scrutin
     ouvert et une personne connectée. La campagne vient du cache du lecteur
     commun (bisou-global-banners). Pas de réponse : la tuile ne change pas. ─── */
  function verifierVote() {
    if (voteVu || !connecte) return;
    var client = root.getAttribute('data-bme-client');
    var cfg = null;
    try {
      var o = JSON.parse(sessionStorage.getItem('bisou_vote_config'));
      cfg = o && o.v;
    } catch (e) {}
    var c = cfg && cfg.campaign;
    if (!client || !c || !c.id || c.is_test || c.open !== true) return;
    voteVu = true;
    var API = String(window.BISOU_VOTE_API || 'https://artists.bisourivage.fr').replace(/\/+$/, '');
    fetch(API + '/api/vote/status?campaign_id=' + encodeURIComponent(c.id) + '&customer_id=' + encodeURIComponent(client), { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (st) {
        if (!st || !st.has_voted) return;
        root.classList.add('a-vote');
        var fait = root.querySelector('[data-bme-a-vote]');
        if (fait) fait.hidden = false;
        var cta = root.querySelector('[data-bme-vote-cta]');
        if (cta) cta.textContent = libelle('voir-vote', EN ? 'See my vote' : 'Voir mon vote');
      })
      .catch(function () {});
  }
  document.addEventListener('bisou:vote-ready', function () {
    if (root.classList.contains('is-ouvert')) verifierVote();
  });

  /* ─── 28/10 : « Mes votes » et « Mes trophées ». Un seul appel, à la première ouverture, par l'App Proxy
     de la boutique (adresse relative, cookies compris : Shopify dit qui est connecté, rien dans l'adresse).
     4 s au plus ; sans réponse, les deux blocs restent cachés. Rien n'est écrit. ─── */
  var TX = {};
  try { TX = JSON.parse((document.getElementById('BmeTextes') || {}).textContent || '{}'); } catch (e) {}
  function tx(k, v) {
    return String(TX[k] || '').replace(/\{(\w+)\}/g, function (m, n) { return v && v[n] != null ? v[n] : m; });
  }
  function el(tag, cls, texte) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (texte != null) n.textContent = texte;
    return n;
  }
  var mvVu = false;
  function numero(label) { var m = /(\d+)/.exec(String(label || '')); return m ? +m[1] : 0; }
  function nomSaison(label) { var n = numero(label); return n ? tx('saison', { n: n }) : String(label || ''); }
  /* 29/10 (langues, Mon espace 5) : la date de « Voté le … » dans la langue de la page. EN seul donnait
     « Votado el 12 October » et 「12 Octoberに投票」 en espagnol et en japonais. */
  var DATE_LOC = { en: 'en-GB', es: 'es-ES', ja: 'ja-JP' }[(document.documentElement.getAttribute('lang') || 'fr').slice(0, 2).toLowerCase()] || 'fr-FR';
  function dateCourte(iso) {
    var d = new Date(iso);
    if (isNaN(d)) return '';
    var o = { day: 'numeric', month: 'long' };
    if (d.getFullYear() !== new Date().getFullYear()) o.year = 'numeric';
    try { return d.toLocaleDateString(DATE_LOC, o); } catch (e) { return ''; }
  }
  /* Le même compte que le SAS (scoreOf de bisou-vote-sas-js-4) : ses 5 choix contre le top 5 figé. */
  function score(p, pub) {
    var hits = p.filter(function (k) { return pub.indexOf(k) > -1; }).length;
    var exact5 = p.length === 5 && pub.length === 5 && p.every(function (k, i) { return k === pub[i]; });
    var exact3 = !!p[0] && p[0] === pub[0] && p[1] === pub[1] && p[2] === pub[2];
    var trois = function (a) { return a.slice(0, 3).slice().sort().join('|'); };
    return {
      hits: hits, n1: !!p[0] && p[0] === pub[0], top3: exact3, perfect: exact5, all5: hits === 5 && !exact5,
      trio: !exact3 && p.length >= 3 && pub.length >= 3 && trois(p) === trois(pub), last: !!p[4] && p[4] === pub[4]
    };
  }
  function vignette(img, titre, w) {
    var u = String(img || '');
    if (u.indexOf('https://') !== 0) return null;
    /* Le CDN de la boutique rend la bonne largeur ; le stockage du vote sert l'image telle quelle. */
    if (/\/cdn\/shop\/|cdn\.shopify\.com/.test(u)) u = image(u, w);
    var i = document.createElement('img');
    i.src = u;
    i.alt = titre || '';
    i.loading = 'lazy';
    i.decoding = 'async';
    return i;
  }

  /* Les saisons votées, de la plus récente à la plus ancienne, avec leur top 5 figé s'il existe. */
  function lireSaisons(j) {
    var gagnantes = {};
    (j.seasons || []).forEach(function (s) {
      gagnantes[s.campaign_id] = (s.winners || []).slice().sort(function (a, b) { return a.position - b.position; })
        .map(function (g) { return g.block_id; }).slice(0, 5);
    });
    return (j.history || []).map(function (b) {
      var p = ['1', '2', '3', '4', '5'].map(function (r) { return b.rankings && b.rankings[r]; }).filter(Boolean);
      var pub = gagnantes[b.campaign_id] || null;
      return { id: b.campaign_id, label: b.label, n: numero(b.label), le: b.submitted_at, p: p, pub: pub, sc: pub ? score(p, pub) : null, clos: b.status === 'closed', meta: b.meta || {}, img: (j.photos && j.photos[b.campaign_id]) || {} };
    });
  }

  function rangee(s, cls, w) {
    var ol = el('ol', cls);
    s.p.forEach(function (bloc, i) {
      var ph = s.img[bloc] || {};
      var im = vignette(ph.image, ph.title, w);
      /* Une saison d'avant sans image gardée : le rang seul, au centre de la case. */
      var li = el('li', 'bme__mv-photo' + (s.pub && s.pub.indexOf(bloc) > -1 ? ' est-elue' : '') + (im ? '' : ' sans-image'));
      if (im) li.appendChild(im);
      li.appendChild(el('span', 'bme__mv-rang', String(i + 1)));
      if (s.pub && s.pub.indexOf(bloc) > -1) li.setAttribute('title', (ph.title ? ph.title + ' · ' : '') + tx('dans_top'));
      else if (ph.title) li.setAttribute('title', ph.title);
      ol.appendChild(li);
    });
    return ol;
  }

  function carteSaison(s) {
    var c = el('article', 'bme__mv-carte');
    var tete = el('p', 'bme__mv-tete');
    tete.appendChild(el('b', null, nomSaison(s.label)));
    var d = dateCourte(s.le);
    if (d) tete.appendChild(el('span', null, tx('vote_le', { date: d })));
    c.appendChild(tete);
    c.appendChild(rangee(s, 'bme__mv-photos', 240));
    if (!s.sc) {
      /* 28/10 : une saison close sans top 5 figé (la S6) n'a pas de résultat à venir : rien d'écrit. */
      if (!s.clos) c.appendChild(el('p', 'bme__mv-attend', tx('a_venir')));
      return c;
    }
    var bilan = el('div', 'bme__mv-bilan');
    var chiffre = el('p', 'bme__mv-chiffre');
    chiffre.appendChild(el('b', null, String(s.sc.hits)));
    chiffre.appendChild(el('span', null, '/5'));
    bilan.appendChild(chiffre);
    var mots = el('div', 'bme__mv-mots');
    mots.appendChild(el('p', null, s.sc.hits === 0 ? tx('score_0') : s.sc.hits === 5 ? tx('score_5') : tx('score')));
    var badges = [];
    if (s.sc.n1) badges.push(tx('n1'));
    if (s.sc.top3) badges.push(tx('top3'));
    if (badges.length) {
      var b = el('p', 'bme__mv-badges');
      badges.forEach(function (t) { b.appendChild(el('span', null, t)); });
      mots.appendChild(b);
    }
    bilan.appendChild(mots);
    c.appendChild(bilan);
    return c;
  }

  function ligneSaison(s) {
    var li = el('li', 'bme__mv-ligne');
    li.appendChild(el('b', null, nomSaison(s.label)));
    li.appendChild(rangee(s, 'bme__mv-mini', 120));
    li.appendChild(el('span', 'bme__mv-note', s.sc ? s.sc.hits + '/5' : s.clos ? '' : '…'));
    return li;
  }

  /* Les trophées que le SAS calcule depuis l'historique seul (ceux du navigateur — partage, rejeu, lettre — n'y sont pas). */
  var ICO = {
    rw: '<path d="M8 4h8v5a4 4 0 0 1-8 0z"/><path d="M8 6H5a3 3 0 0 0 3 4M16 6h3a3 3 0 0 1-3 4"/><path d="M12 13v4M9 20h6"/>',
    fl: '<circle cx="12" cy="12" r="3"/><path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z"/>',
    fi: '<path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8-4.3-4.1 5.9-.9z"/>'
  };
  function trophees(saisons, dernierClos) {
    var closes = saisons.filter(function (s) { return s.sc; });
    var gagne = function (f) { return closes.filter(f).map(function (s) { return s.n || s.label; }); };
    /* Comme le SAS : la série part de la saison en cours si elle est votée, sinon de la dernière close. */
    var nums = {}, plusHaut = dernierClos || 0;
    saisons.forEach(function (s) { if (s.n) { nums[s.n] = 1; plusHaut = Math.max(plusHaut, s.n); } });
    var serie = 0;
    for (var n = plusHaut; n > 0 && nums[n]; n--) serie++;
    var run = 0, meilleur = 0, prec = null;
    closes.slice().sort(function (a, b) { return a.n - b.n; }).forEach(function (s) {
      run = s.sc.hits >= 3 ? (prec && prec.n === s.n - 1 && prec.sc.hits >= 3 ? run + 1 : 1) : 0;
      meilleur = Math.max(meilleur, run);
      prec = s;
    });
    var meilleurScore = closes.reduce(function (m, s) { return Math.max(m, s.sc.hits); }, 0);
    var n1 = gagne(function (s) { return s.sc.n1; });
    var L = function (id, sec, tier, list) { return { id: id, sec: sec, tier: tier, list: list, got: list.length > 0 }; };
    var P = function (id, sec, tier, p, of) { return { id: id, sec: sec, tier: tier, p: Math.min(p, of), of: of, got: p >= of }; };
    return [
      L('perfect', 'rw', 'plat', gagne(function (s) { return s.sc.perfect; })),
      L('top3', 'rw', 'gold', gagne(function (s) { return s.sc.top3; })),
      L('all5', 'rw', 'gold', gagne(function (s) { return s.sc.all5; })),
      L('n1', 'rw', 'gold', n1),
      P('eye', 'fl', 'silver', meilleurScore, 4),
      L('podium', 'fl', 'silver', gagne(function (s) { return s.sc.trio; })),
      L('last', 'fl', 'silver', gagne(function (s) { return s.sc.last; })),
      P('double', 'fl', 'silver', n1.length, 2),
      P('steady', 'fl', 'silver', meilleur, 3),
      P('first', 'fi', 'bronze', saisons.length, 1),
      P('streak3', 'fi', 'bronze', serie, 3),
      P('streak6', 'fi', 'silver', serie, 6),
      P('streak12', 'fi', 'plat', serie, 12),
      P('v5', 'fi', 'bronze', saisons.length, 5),
      P('v10', 'fi', 'silver', saisons.length, 10),
      P('v25', 'fi', 'plat', saisons.length, 25)
    ];
  }
  function medaille(x) {
    var m = el('span', 'bme__tr-medaille bme__tr--' + (x.got ? x.tier : 'lock'));
    m.setAttribute('aria-hidden', 'true');
    m.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" focusable="false">' + ICO[x.sec] + '</svg>';
    return m;
  }

  function remplirTrophees(saisons, dernierClos) {
    var bloc = root.querySelector('[data-bme-tr]');
    var corps = root.querySelector('[data-bme-tr-corps]');
    if (!bloc || !corps) return;
    var T = trophees(saisons, dernierClos);
    var gagnes = T.filter(function (x) { return x.got; });
    var total = root.querySelector('[data-bme-tr-total]');
    if (total) total.textContent = gagnes.length ? tx(gagnes.length > 1 ? 'tr_gagnes' : 'tr_gagnes_1', { n: gagnes.length }) : '';
    corps.textContent = '';
    if (gagnes.length) {
      var ul = el('ul', 'bme__tr-gagnes');
      gagnes.forEach(function (x) {
        var li = el('li', 'bme__tr-un');
        li.appendChild(medaille(x));
        li.appendChild(el('b', null, tx('tr_' + x.id)));
        var quand = x.list ? (x.list.length > 1 ? '×' + x.list.length : (typeof x.list[0] === 'number' ? tx('saison', { n: x.list[0] }) : '')) : '';
        if (quand) li.appendChild(el('small', null, quand));
        li.setAttribute('title', tx('tr_' + x.id + '_how'));
        ul.appendChild(li);
      });
      corps.appendChild(ul);
    }
    /* Le prochain : celui qui a une barre (progression connue) et le plus avancé ; à égalité, le plus proche du but. */
    var suivants = T.filter(function (x) { return !x.got && x.of; }).sort(function (a, b) {
      return (b.p / b.of - a.p / a.of) || (a.of - a.p) - (b.of - b.p);
    });
    var x = suivants[0];
    if (!x) return;
    var pr = el('div', 'bme__tr-prochain');
    pr.appendChild(medaille(x));
    var t = el('div', 'bme__tr-texte');
    t.appendChild(el('small', null, tx('tr_prochain')));
    t.appendChild(el('b', null, tx('tr_' + x.id)));
    t.appendChild(el('p', null, tx('tr_' + x.id + '_how')));
    var barre = el('span', 'bme__tr-barre');
    barre.setAttribute('role', 'progressbar');
    barre.setAttribute('aria-valuemin', '0');
    barre.setAttribute('aria-valuemax', String(x.of));
    barre.setAttribute('aria-valuenow', String(x.p));
    barre.setAttribute('aria-label', tx('tr_' + x.id));
    var plein = el('i');
    plein.style.setProperty('--bme-p', String(Math.max(x.p / x.of, 0)));
    barre.appendChild(plein);
    t.appendChild(barre);
    pr.appendChild(t);
    pr.appendChild(el('span', 'bme__tr-compte', x.p + '/' + x.of));
    corps.appendChild(pr);
  }

  function remplirVotes(j) {
    var bloc = root.querySelector('[data-bme-mv]');
    var corps = root.querySelector('[data-bme-mv-corps]');
    if (!bloc || !corps) return;
    var saisons = lireSaisons(j);
    corps.textContent = '';
    bloc.removeAttribute('aria-busy');
    var total = root.querySelector('[data-bme-mv-total]');
    if (total) total.textContent = saisons.length ? tx(saisons.length > 1 ? 'total' : 'total_1', { n: saisons.length }) : '';
    if (!saisons.length) {
      /* Jamais voté : un bulletin vide qui donne envie de le remplir. */
      var v = el('div', 'bme__mv-vide');
      var ol = el('ol', 'bme__mv-photos bme__mv-photos--vide');
      ol.setAttribute('aria-hidden', 'true');
      for (var i = 1; i <= 5; i++) ol.appendChild(el('li', 'bme__mv-photo', String(i)));
      v.appendChild(ol);
      v.appendChild(el('p', 'bme__mv-vide-titre', tx('vide_titre')));
      v.appendChild(el('p', 'bme__note', tx('vide_texte')));
      var a = el('a', 'bme__voir bme__mv-cta', tx('vide_cta') + ' ');
      a.href = ROOT + '/pages/vote';
      a.appendChild(el('span', null, '→')).setAttribute('aria-hidden', 'true');
      v.appendChild(a);
      corps.appendChild(v);
    } else {
      corps.appendChild(carteSaison(saisons[0]));
      if (saisons.length > 1) {
        corps.appendChild(el('p', 'bme__mv-avant', tx('avant')));
        var ul = el('ul', 'bme__mv-lignes');
        saisons.slice(1, 4).forEach(function (s) { ul.appendChild(ligneSaison(s)); });
        corps.appendChild(ul);
      }
    }
    remplirTrophees(saisons, (j.seasons || []).reduce(function (m, s) { return Math.max(m, numero(s.label)); }, 0));
    var tr = root.querySelector('[data-bme-tr]');
    if (tr) tr.hidden = false;
  }

  function cacherVotes() {
    ['[data-bme-mv]', '[data-bme-tr]'].forEach(function (s) { var b = root.querySelector(s); if (b) b.hidden = true; });
  }

  function chargerVotes() {
    if (mvVu || !connecte || !root.querySelector('[data-bme-mv]')) return;
    mvVu = true;
    root.querySelector('[data-bme-mv]').hidden = false;
    var fini = false;
    var minuterie = setTimeout(function () { if (!fini) { fini = true; cacherVotes(); } }, 4000);
    fetch('/apps/bisou-vote/mes-votes?avec=images', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (fini) return;
        fini = true;
        clearTimeout(minuterie);
        if (!j || !j.ok || !j.logged_in || !Array.isArray(j.history)) { cacherVotes(); return; }
        remplirVotes(j);
      })
      .catch(function () { if (!fini) { fini = true; clearTimeout(minuterie); cacherVotes(); } });
  }

  /* ─── La connexion ramène sur la page de départ (adresse relative). ─── */
  function majConnexion() {
    var lien = root.querySelector('[data-bme-connexion]');
    if (!lien) return;
    /* Shopify rend ce lien en adresse absolue (…/customer_authentication/redirect) :
       on le lit comme une adresse, pas comme un texte. */
    var u;
    try { u = new URL(lien.getAttribute('href') || '', location.href); } catch (e) { return; }
    if (u.origin !== location.origin || u.pathname.indexOf('/customer_authentication/') !== 0) return;
    /* 25/10 (site anglais) : hors français, la page de connexion garde la langue (locale=en, comme le lien de Shopify).
       27/10 : celle du lien de Shopify (es, ja), plus « en » pour toutes. */
    var loc = u.searchParams.get('locale') || (EN ? 'en' : 'fr');
    lien.setAttribute('href', '/customer_authentication/login?return_to=' + encodeURIComponent(location.pathname + location.search) + (loc !== 'fr' ? '&locale=' + encodeURIComponent(loc) : ''));
  }

  /* ─── Ouvrir, fermer ─── */
  function fermerMenu() {
    var menu = document.getElementById('bisou-volet');
    if (!menu || menu.getAttribute('aria-hidden') !== 'false') return;
    var x = menu.querySelector('.bisou-volet__close');
    if (x) x.click(); else menu.setAttribute('aria-hidden', 'true');
  }

  function ouvrir(source) {
    if (root.classList.contains('is-ouvert')) return;
    avant = source || document.activeElement;
    fermerMenu();
    remplirEnvies();
    majConnexion();
    root.hidden = false;
    document.documentElement.classList.add('bme-ouvert');
    void volet.offsetWidth;
    root.classList.add('is-ouvert');
    volet.focus({ preventScroll: true });
    verifierVote();
    chargerVotes();
  }

  function fermer() {
    if (!root.classList.contains('is-ouvert')) return;
    root.classList.remove('is-ouvert');
    document.documentElement.classList.remove('bme-ouvert');
    var fini = false;
    function cacher() {
      if (fini) return;
      fini = true;
      if (!root.classList.contains('is-ouvert')) root.hidden = true;
    }
    volet.addEventListener('transitionend', cacher, { once: true });
    setTimeout(cacher, 400);
    if (avant && typeof avant.focus === 'function' && document.contains(avant)) avant.focus({ preventScroll: true });
    avant = null;
  }

  function estDeclencheur(a) {
    if (!a) return false;
    if (a.hasAttribute('data-bme-ouvrir')) return true;
    /* La tuile « Mon espace » du menu tiroir : le lien du compte, une fois connecté. */
    return connecte && !!compte && a.getAttribute('href') === compte && !!a.closest('#bisou-volet');
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-bme-fermer]')) { e.preventDefault(); fermer(); return; }
    var a = t.closest('a[href]');
    if (!estDeclencheur(a)) return;
    e.preventDefault();
    ouvrir(a);
  });

  document.addEventListener('keydown', function (e) {
    if (!root.classList.contains('is-ouvert')) return;
    if (e.key === 'Escape') { e.preventDefault(); fermer(); return; }
    if (e.key !== 'Tab') return;
    var f = visibles();
    if (!f.length) { e.preventDefault(); return; }
    var premier = f[0];
    var dernier = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === premier || document.activeElement === volet)) {
      e.preventDefault();
      dernier.focus();
    } else if (!e.shiftKey && document.activeElement === dernier) {
      e.preventDefault();
      premier.focus();
    }
  });

  /* La liste d'envies change dans un autre onglet : le volet suit. */
  window.addEventListener('storage', function (e) {
    if (e.key === 'br_wishlist_v1' && root.classList.contains('is-ouvert')) remplirEnvies();
  });

  /* Pour l'essai : window.BisouMonEspace.ouvrir() */
  window.BisouMonEspace = { ouvrir: function () { ouvrir(null); }, fermer: fermer };
})();
